export default __webpack_public_path__ + "assets/80c27e5918f25807ec13e88ef9e724fb.svg";